<template>
  <div class="login-bg">
    <div class="login">
      
      <transition name="slide-fade">>
          <div class="card login-box" v-if="show" v-loading="loading">
            <form @submit.prevent="login()">
              <div class="card-body">
                <div class='text-center'>
                  <img src="../assets/logo2.png" class="img-responsive img-logo" />
                </div>
                <hr/>
                <h5 class="card-title">{{ $t("login.title") }} </h5>
                <h6 class="card-subtitle mb-2 text-muted">{{ $t("login.subtitle") }}</h6>

                <div class="form-group">
                  <label>{{ $t("login.email_address") }}</label>
                  <input type="email" class="form-control" v-model="email" :placeholder='$t("login.enter_email")'>
                  <small class="form-text text-muted">{{ $t("login.never_share") }}</small>
                  </div>
                <div class="form-group">
                  <label >{{ $t("login.password") }}</label>
                  <input type="password" class="form-control" v-model="password" :placeholder='$t("login.password")'>
                </div>
                <button type="submit" @click="login()" class="btn btn-primary">{{ $t("login.login_button") }}</button>
              </div>
            </form>
          </div>
      </transition>
    </div>
  </div>
</template>

<script>
import settings from "./../backend/LocalSettings";

export default {
  name: "login",
  data () {
    return {
      show: false,
      loading: false,
      email: "",
      password: ""
    }
  },
  methods: {
    login: function() {     
      this.loading = true;
      this.$http
          .post('login/verify', { email: this.email, password: this.password } )
          .then(function (response) {
            this.loading = false;
            if ( response.body.Token != "") {
              //this.$message( 'Token:' + response.body.Token );
              this.$rights.set_rights( JSON.stringify( response.body.Rights ) );
              settings.set_token( response.body.Token );
              this.$router.push("/dashboard");
            } else {
              this.$message.error('Login error');
            }
          });
    },
    check_login() {
      if( settings.is_logged_in() ){
        this.$router.push("/dashboard");
      }
    }
  },
  mounted: function() {
    this.show = true;
    this.check_login();
  }
};
</script>

<style lang="less" scoped>
  
  .img-logo {
    max-height: 40px;
  }
  .login-box {
    margin: 50px auto;
    width: 320px;
  }

  .slide-fade-enter-active {
    transition: all 1.3s ease;
  }
  .slide-fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateY(250px);
    opacity: 0;
  }
</style>
